/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import DialogContent from "@mui/material/DialogContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";

import Grid from "@mui/material/Grid";
import Loader from "../../../component/loader";

import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import actionTypes from "../../../store/actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { makeStyles } from '@mui/styles';

const ViewRequestorsDialog = (props) => {
  const t = props.t;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     },
  // });

  useEffect(() => {
    setLoading(true);
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${props.requestorListPartyId ? props.requestorListPartyId : props.tenantId}/contracts/${props.contractId}/requests`,
    )
      .then((res) => {
        setLoading(false);
        setData(res.data);
        if (res.data.length === 0) {
          setNoData(true);
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(false);
      });
  }, []);

  const closeDialog = () => {
    props.close();
  };

  const sendContract = (id) => {
    setLoading(true);
    let data = {
      providerIdTo: id,
    };
    BusApiCall(
      "POST",
      `${constants.busV4Url}/providers/${props.tenantId}/contracts/${props.contractId}/send`,
      data,
    )
      .then((res) => {
        props.close(res.data.id);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(false);
      });
  };
  // const classess = useStyles();
  return (
    <>
      <Dialog
        disableScrollLock={true}
        open={props.open}
        maxWidth="md"
        fullWidth={true}
        PaperComponent={DraggableDialogPaper}
        // PaperProps={{
        //     className: classess.resizablePaper
        // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("REQUESTS_FOR_CONTRACT")} - {props.contractTitle}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => closeDialog()}
                onClick={() => closeDialog()}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <TableContainer>
                <Table>
                  {data.map((item, index) => (
                    <React.Fragment key={index}>
                      <TableHead>
                        <TableRow>
                          <TableCell colSpan={3}>
                            <h3>
                              {t("ORGANIZATION")}: {item.requestorOrganization}
                              {props.copyContract && (
                                <Button
                                  onClick={(event) =>
                                    sendContract(item.requestorOrganizationId)
                                  }
                                  color="primary"
                                  style={{ float: "right" }}
                                >
                                  {t("SEND_CONTRACT")}
                                </Button>
                              )}
                            </h3>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <b>{t("FROM")}</b>
                          </TableCell>
                          <TableCell>
                            <b>{t("EMAIL")}</b>
                          </TableCell>
                          <TableCell>
                            <b>{t("REQUESTED_ON")}</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {item.requests.map((req, i) => (
                          <TableRow key={i}>
                            <TableCell>{req.name}</TableCell>
                            <TableCell>{req.email}</TableCell>
                            <TableCell>
                              {req.requestedDate.split(" ")[0]}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </React.Fragment>
                  ))}
                  {noData && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          align="center"
                          style={{ borderBottom: "none" }}
                        >
                          {t("NO_REQUESTS_FOUND")}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        {/* <DialogActions>
                    <Button onClick={event => closeDialog()} color="primary">{t('CLOSE')}</Button>
                </DialogActions> */}
      </Dialog>
      <Loader loading={loading} />
    </>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ViewRequestorsDialog));
